// Reusable status pill — drives all status visuals across the app.
import { STATUS_PILL } from "@/lib/constants";

export default function Pill({ tone = "neutral", children, className = "", icon: Icon, ...rest }) {
    const c = STATUS_PILL[tone] || STATUS_PILL.neutral;
    return (
        <span
            {...rest}
            className={`inline-flex items-center gap-1 px-2.5 py-0.5 rounded-full text-[11px] font-semibold whitespace-nowrap ${className}`}
            style={{ background: c.bg, color: c.fg }}
        >
            {Icon ? <Icon className="w-3 h-3" /> : null}
            {children}
        </span>
    );
}
